export const googleApiKey: string = import.meta.env.VITE_GOOGLE_API_KEY as string ?? null
